import { createFileRoute } from '@tanstack/react-router';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import { loaderUnitPublicationsPage } from '@/loaders/unit.publications.loader';
import { UnitPublicationsPage } from '@/routes/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/publications';

export const Route = createFileRoute('/_authenticated/_account/units/$endCustomerUnitId/publications/')({
  component: UnitPublicationsPage,
  errorComponent: ErrorBoundary,
  loader: loaderUnitPublicationsPage,
});
